module.exports = __webpack_public_path__ + "static/media/profile.9ffa8d1d.png";